import { setCookie } from "./functions/functions";
import validator from "./functions/validate";
import autocomplete from "./functions/autocomplete";

/**
 * auto complete function calls
 */
autocomplete("person_city");
autocomplete("person_state");

/**
 * validator function calls
 */
// validator(".check-background-form", function () {
//     let age = document.getElementById("ageRange");
//     age.value = slider.noUiSlider.get();
//     document.querySelector(".check-background-form").submit();
// });
validator(".add-response-forms-auth-no-report", function () {
    let form = document.getElementById("submit-background-report");
    try {
        let firstName = document.getElementById("first_name").value;
        let lastName = document.getElementById("last_name").value;
        document.getElementById("person_name").value =
            firstName + " " + lastName;
    } catch (error) {}
    form.submit();
});
validator(".add-response-forms-auth-report", function () {
    let form = document.getElementById("submit-background-report");

    try {
        let firstName = document.getElementById("first_name").value;
        let lastName = document.getElementById("last_name").value;
        document.getElementById("person_name").value =
            firstName + " " + lastName;
    } catch (error) {}

    let overlay = document.querySelector(".overlay");
    overlay.classList.remove("d-none");
    let url = form.getAttribute("action");
    let data = new FormData(form);
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let redirect = form.getAttribute("data-redirect");
    fetch(url, {
        method: "POST",
        headers: {
            "X-CSRF-TOKEN": csrf_token,
        },
        body: data,
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (result) {
            if (result.status == true) {
                window.location.href = redirect;
            } else {
                overlay.classList.add("d-none");
                alert("Something went wrong!");
            }
        })
        .catch((error) => {
            overlay.classList.add("d-none");
            alert("Something went wrong. Please try again.");
        });
});
validator(".add-response-forms-no-auth", function () {
    let form = document.getElementById("submit-background-report");
    try {
        let firstName = document.getElementById("first_name").value;
        let lastName = document.getElementById("last_name").value;
        document.getElementById("person_name").value =
            firstName + " " + lastName;
    } catch (error) {}
    window.location.href = form.getAttribute("action");
});
validator(".register-form", function () {
    let response = grecaptcha.getResponse();
    let reValidte = document.getElementById("recaptcha");
    if (response.length == 0) {
        reValidte.innerText = "You must fill the captcha!";
        return false;
    } else {
        reValidte.innerText = "";
    }
    document.querySelector(".register-form").submit();
});
validator(".login-form", function () {
    document.querySelector(".login-form").submit();
});
validator(".password-send-email", function () {
    let response = grecaptcha.getResponse();
    let reValidte = document.getElementById("recaptcha");
    if (response.length == 0) {
        reValidte.innerText = "You must fill the captcha!";
        return false;
    } else {
        reValidte.innerText = "";
    }
    document.querySelector(".password-send-email").submit();
});
validator(".password-reset-form", function () {
    document.querySelector(".password-reset-form").submit();
});
validator(".search-people-form", function () {
    let form = document.querySelector(".search-people-form");
    let age = document.getElementById("ageRange");
    age.value = slider.noUiSlider.get();
    // let count = 0;
    let pageLoader = document.querySelector(".preloader");
    let response = grecaptcha.getResponse();
    let reValidte = document.getElementById("recaptcha");
    if (response.length == 0) {
        reValidte.innerText = "You must fill the captcha!";
        return false;
    } else {
        reValidte.innerText = "";
    }
    pageLoader.classList.remove("d-none");
    pageLoader.classList.add("d-block");

    form.submit();
});
//create report form (front) submit
// validator(".create-background-from-f", function () {
//     let form = document.querySelector(".create-background-from-f");
//     let firstName = document.getElementById("first_name").value;
//     let lastName = document.getElementById("last_name").value;
//     document.getElementById("person_name").value = firstName + " " + lastName;
//     form.submit();
// });
//create report form (temp:submit) start
validator(".create-background-submit-auth-no-report", function () {
    let form = document.getElementById("create-background-submit");
    //for background submit front form
    try {
        let firstName = document.getElementById("first_name").value;
        let lastName = document.getElementById("last_name").value;
        document.getElementById("person_name").value =
            firstName + " " + lastName;
    } catch (error) {}

    //for background submit dashboard form
    let age = document.getElementById("ageRange");
    try {
        age.value = slider.noUiSlider.get();
    } catch (error) {}

    //for all
    form.submit();
});
validator(".create-background-submit-auth-report", function () {
    let form = document.getElementById("create-background-submit");
    //for background submit front form
    try {
        let firstName = document.getElementById("first_name").value;
        let lastName = document.getElementById("last_name").value;
        document.getElementById("person_name").value =
            firstName + " " + lastName;
    } catch (error) {}

    //for background submit dashboard form
    let age = document.getElementById("ageRange");
    try {
        age.value = slider.noUiSlider.get();
    } catch (error) {}

    //for all
    let overlay = document.querySelector(".overlay");
    overlay.classList.remove("d-none");
    let url = form.getAttribute("action");
    let data = new FormData(form);
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let redirect = form.getAttribute("data-redirect");
    fetch(url, {
        method: "POST",
        headers: {
            "X-CSRF-TOKEN": csrf_token,
        },
        body: data,
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (result) {
            if (result.status == true) {
                window.location.href = redirect;
            } else {
                overlay.classList.add("d-none");
                alert("Something went wrong!");
            }
        })
        .catch((error) => {
            overlay.classList.add("d-none");
            alert("Something went wrong. Please try again.");
        });
});
validator(".create-background-submit-no-auth", function () {
    let form = document.getElementById("create-background-submit");
    //for background submit front form
    try {
        let firstName = document.getElementById("first_name").value;
        let lastName = document.getElementById("last_name").value;
        document.getElementById("person_name").value =
            firstName + " " + lastName;
    } catch (error) {}

    //for background submit dashboard form
    let age = document.getElementById("ageRange");
    try {
        age.value = slider.noUiSlider.get();
    } catch (error) {}

    //for all
    form.submit();
    // window.location.href = form.getAttribute("action");
});
//create report form (temp:submit) end
validator("payment-form", function () {
    window.location.href = document
        .getElementById("payment-form")
        .getAttribute("action");
});
validator(".family-search", function () {
    let form = document.querySelector(".family-search");
    let pageLoader = document.querySelector(".preloader");
    let response = grecaptcha.getResponse();
    let reValidte = document.getElementById("recaptcha");
    if (response.length == 0) {
        reValidte.innerText = "You must fill the captcha!";
        return false;
    } else {
        reValidte.innerText = "";
    }
    pageLoader.classList.remove("d-none");
    pageLoader.classList.add("d-block");

    form.submit();
});
validator(".contact-us-form", function () {
    document.querySelector(".contact-us-form").submit();
});
validator(".change-password-form", function () {
    let form = document.getElementById("change_password_form");
    let url = form.getAttribute("action");
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let current_pass_error = document.getElementById("current_pass_error");
    let new_pass_error = document.getElementById("new_pass_error");
    let confirm_pass_error = document.getElementById("re_pass_error");
    let data = new FormData(form);
    let submit_btn = document.getElementById("c-password-submit");
    submit_btn.querySelector("div").classList.remove("d-none");
    submit_btn.disabled = true;
    // current_pass_error.innerText = '';
    // new_pass_error.innerText = '';
    // confirm_pass_error.innerText = '';
    // console.log(data.get('current_password'));
    try {
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrf_token,
            },
            body: data,
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                submit_btn.querySelector("div").classList.add("d-none");
                submit_btn.disabled = false;
                if (result.current_password) {
                    current_pass_error.innerText = result.current_password[0];
                }
                if (result.password) {
                    new_pass_error.innerText = result.password[0];
                }
                if (result.password_confirmation) {
                    confirm_pass_error.innerText =
                        result.password_confirmation[0];
                }
                if (result.success) {
                    form.classList.add("d-none");
                    document.getElementById("success_msg").innerText =
                        result.success;
                    document
                        .getElementById("password_changed")
                        .classList.remove("d-none");
                }
            });
    } catch (error) {
        alert("Something Went Wrong!");
    }
});
validator(".delete-account-form", function () {
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let form = document.getElementById("delete_account_form");
    let url = form.getAttribute("action");
    let current_pass_error = document.getElementById("current_pass_error_d");
    let data = new FormData(form);
    let delete_account = document.getElementById("deactivate-account");
    delete_account.querySelector("div").classList.remove("d-none");
    delete_account.disabled = true;
    // console.log(data.get('current_password'));
    try {
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrf_token,
            },
            body: data,
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                delete_account.querySelector("div").classList.add("d-none");
                delete_account.disabled = false;
                if (result.current_password) {
                    current_pass_error.innerText = result.current_password[0];
                }
                if (result.password) {
                    new_pass_error.innerText = result.password[0];
                }
                if (result.password_confirmation) {
                    confirm_pass_error.innerText =
                        result.password_confirmation[0];
                }
                if (result.success) {
                    location.reload();
                }
            });
    } catch (error) {
        alert("Something Went Wrong!");
    }
});
validator("#trial-end-form", function () {
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let form = document.getElementById("trial-end-form");
    let url = form.getAttribute("action");
    let current_pass_error = document.getElementById("current_pass_error_trial_end");
    let data = new FormData(form);
    let submitBtn = document.getElementById("trial-end-confirm");
    submitBtn.querySelector("div").classList.remove("d-none");
    submitBtn.disabled = true;
    // console.log(data.get('current_password'));
    try {
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrf_token,
            },
            body: data,
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                submitBtn.querySelector("div").classList.add("d-none");
                submitBtn.disabled = false;
                if (result.current_password) {
                    current_pass_error.innerText = result.current_password[0];
                }
                if (result.password) {
                    new_pass_error.innerText = result.password[0];
                }
                if (result.password_confirmation) {
                    confirm_pass_error.innerText =
                        result.password_confirmation[0];
                }
                if (result.success) {
                    location.reload();
                }
            });
    } catch (error) {
        alert("Something Went Wrong!");
    }
});
validator("#subscription-cancel-form", function () {
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let form = document.getElementById("subscription-cancel-form");
    let url = form.getAttribute("action");
    let current_pass_error = document.getElementById("current_pass_error_subscription_cancel");
    let data = new FormData(form);
    let submitBtn = document.getElementById("subscription-cancel-confirm");
    submitBtn.querySelector("div").classList.remove("d-none");
    submitBtn.disabled = true;
    // console.log(data.get('current_password'));
    try {
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrf_token,
            },
            body: data,
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                submitBtn.querySelector("div").classList.add("d-none");
                submitBtn.disabled = false;
                if (result.current_password) {
                    current_pass_error.innerText = result.current_password[0];
                }
                if (result.password) {
                    new_pass_error.innerText = result.password[0];
                }
                if (result.password_confirmation) {
                    confirm_pass_error.innerText =
                        result.password_confirmation[0];
                }
                if (result.success) {
                    location.reload();
                }
            });
    } catch (error) {
        alert("Something Went Wrong!");
    }
});

validator("#subscription-resume-form", function () {
    let csrf_token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    let form = document.getElementById("subscription-resume-form");
    let url = form.getAttribute("action");
    let current_pass_error = document.getElementById("current_pass_error_subscription_resume");
    let data = new FormData(form);
    let submitBtn = document.getElementById("subscription-resume-confirm");
    submitBtn.querySelector("div").classList.remove("d-none");
    submitBtn.disabled = true;
    // console.log(data.get('current_password'));
    try {
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrf_token,
            },
            body: data,
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                submitBtn.querySelector("div").classList.add("d-none");
                submitBtn.disabled = false;
                if (result.current_password) {
                    current_pass_error.innerText = result.current_password[0];
                }
                if (result.password) {
                    new_pass_error.innerText = result.password[0];
                }
                if (result.password_confirmation) {
                    confirm_pass_error.innerText =
                        result.password_confirmation[0];
                }
                if (result.success) {
                    location.reload();
                }
            });
    } catch (error) {
        alert("Something Went Wrong!");
    }
});

{
    window.onload = () => {
        try {
            document.querySelector(".preloader").classList.add("d-none");
        } catch (error) {}
        try {
            document.querySelector("body").classList.remove("overflow-hidden");
        } catch (error) {}
        try {
            document.querySelector("body").classList.add("b-overflow-y-auto");
        } catch (error) {}
    };
}

//scroll to
{
    let scrollToBtn = document.querySelectorAll(".scroll-to");
    [].forEach.call(scrollToBtn, function (el) {
        el.addEventListener("click", function (e) {
            e.preventDefault();
            let elemId = this.getAttribute("href").replace("#", "");
            let element = document.getElementById(elemId);
            let offset = 55;
            let bodyRect = document.body.getBoundingClientRect().top;
            let elementRect = element.getBoundingClientRect().top;
            let elementPosition = elementRect - bodyRect;
            let offsetPosition = elementPosition - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        });
    });
}
//theme changer
{
    let mode_changer = document.querySelectorAll(".mode-changer");
    [].forEach.call(mode_changer, (el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            // alert(true);

            let body = document.querySelector("body");
            let modeChangerIcon =
                document.querySelectorAll(".mode-changer-icon");
            let modeChangerTitle = document.querySelectorAll(
                ".mode-changer-title"
            );

            body.classList.toggle("dark-theme");
            try {
                [].forEach.call(modeChangerIcon, (el) => {
                    let darkThemeIcon = el.getAttribute("data-dark_theme_img");
                    let whiteThemeIcon = el.getAttribute(
                        "data-white_theme_img"
                    );
                    if (body.classList.contains("dark-theme")) {
                        el.setAttribute("src", darkThemeIcon);
                    } else {
                        el.setAttribute("src", whiteThemeIcon);
                    }
                });
            } catch (error) {}

            try {
                [].forEach.call(modeChangerTitle, (el) => {
                    if (body.classList.contains("dark-theme")) {
                        el.innerText = "Switch Light";
                    } else {
                        el.innerText = "Switch Dark";
                    }
                });
            } catch (error) {}
            try {
                if (body.classList.contains("dark-theme")) {
                    setCookie("theme", "dark-theme");
                } else {
                    setCookie("theme", "white-theme");
                }
            } catch (error) {}
        });
    });
}
//form switch effect
try {
    let loginUrl = document
        .getElementById("login-form")
        .getAttribute("data-link");
    let registerUrl = document
        .getElementById("register-form")
        .getAttribute("data-link");
    let signIn = document.querySelector(".go-sign-in");
    let signUp = document.querySelector(".go-sign-up");
    let title = document.querySelector("title");
    let loginSection = document.querySelector(".login-section");
    let registerSection = document.querySelector(".register-section");
    let disclaimerWrapper = document.querySelector(".disclaimer-wrapper");
    let footerImg = document.querySelector(".footer-img");
    signIn.addEventListener("click", (e) => {
        e.preventDefault();
        let PageTitle = e.currentTarget.getAttribute("data-title");
        let state = "";
        window.history.pushState(state, PageTitle, loginUrl);
        title.innerText = PageTitle;
        registerSection.classList.add("form-fade-out");
        setTimeout(() => {
            registerSection.classList.add("d-none");
            loginSection.classList.remove("d-none");
            if (loginSection.classList.contains("form-fade-out")) {
                loginSection.classList.remove("form-fade-out");
            }
            loginSection.classList.add("from-fade-in");

            try {
                disclaimerWrapper.classList.remove("d-none");
            } catch (error) {}
            try {
                footerImg.classList.add("ms-md-auto");
            } catch (error) {}
        }, 300);
    });
    signUp.addEventListener("click", (e) => {
        e.preventDefault();
        let PageTitle = e.currentTarget.getAttribute("data-title");
        let state = "";
        window.history.pushState(state, PageTitle, registerUrl);
        title.innerText = PageTitle;
        loginSection.classList.add("form-fade-out");
        setTimeout(() => {
            loginSection.classList.add("d-none");
            registerSection.classList.remove("d-none");
            if (registerSection.classList.contains("form-fade-out")) {
                registerSection.classList.remove("form-fade-out");
            }
            registerSection.classList.add("form-fade-in");

            try {
                disclaimerWrapper.classList.add("d-none");
            } catch (error) {}
            try {
                footerImg.classList.remove("ms-md-auto");
            } catch (error) {}
        }, 300);
    });
} catch (error) {}
//history back effect
{
    window.addEventListener("popstate", (event) => {
        let url = location.toString().replace(location.search, "");
        let loginUrl = document
            .getElementById("login-form")
            .getAttribute("data-route");
        let registerUrl = document
            .getElementById("register-form")
            .getAttribute("data-route");
        let loginSection = document.querySelector(".login-section");
        let registerSection = document.querySelector(".register-section");
        let disclaimerWrapper = document.querySelector(".disclaimer-wrapper");
        let footerImg = document.querySelector(".footer-img");
        if (loginUrl == url) {
            setTimeout(() => {
                registerSection.classList.add("d-none");
                loginSection.classList.remove("d-none");
                if (loginSection.classList.contains("form-fade-out")) {
                    loginSection.classList.remove("form-fade-out");
                }
                loginSection.classList.add("from-fade-in");

                try {
                    disclaimerWrapper.classList.remove("d-none");
                } catch (error) {}
                try {
                    footerImg.classList.add("ms-md-auto");
                } catch (error) {}
            }, 300);
        }
        if (registerUrl == url) {
            setTimeout(() => {
                loginSection.classList.add("d-none");
                registerSection.classList.remove("d-none");
                if (registerSection.classList.contains("form-fade-out")) {
                    registerSection.classList.remove("form-fade-out");
                }
                registerSection.classList.add("form-fade-in");

                try {
                    disclaimerWrapper.classList.add("d-none");
                } catch (error) {}
                try {
                    footerImg.classList.remove("ms-md-auto");
                } catch (error) {}
            }, 300);
        }
        // alert(loginUrl == url);
    });
}
//back button
{
    let backBtn = document.querySelectorAll(".back");
    [].forEach.call(backBtn, function (el) {
        el.addEventListener("click", function () {
            window.history.back();
        });
    });
}
//profile pic update effect
try {
    let input_profile = document.getElementById("inpout_profile_pic");
    let profile_preview = document.getElementById("profile_pic_preview");

    input_profile.addEventListener("change", function () {
        const [file] = input_profile.files;
        if (file) {
            profile_preview.src = URL.createObjectURL(file);
        }
    });
} catch (error) {}

//password show toggle
{
    let eye = document.querySelectorAll(".eye");
    [].forEach.call(eye, (el) => {
        let input = el.parentElement.querySelector("input");
        let openEye = el.getAttribute("data-openEye");
        let closeEye = el.getAttribute("data-closeEye");
        el.addEventListener("click", (el) => {
            if (input.getAttribute("type") === "password") {
                input.setAttribute("type", "text");
                el.target.setAttribute("src", openEye);
            } else {
                input.setAttribute("type", "password");
                el.target.setAttribute("src", closeEye);
            }
        });
    });
}

//menu toggle
// {
//     //opening menu
//     let menuBtn = document.querySelectorAll(".menu-icon-img");
//     [].forEach.call(menuBtn, (el) => {
//         el.addEventListener("click", (el) => {
//             let menu = document.querySelectorAll(".mobile-nav-menu");
//             [].forEach.call(menu, (el) => {
//                 el.classList.toggle("navbar-nav-effect");
//             });
//         });
//     });
//     //closing menu
//     let closeBtn = document.querySelectorAll(".menu-close-icon");
//     [].forEach.call(closeBtn, (el) => {
//         el.addEventListener("click", (el) => {
//             let menu = document.querySelectorAll(".mobile-nav-menu");
//             [].forEach.call(menu, (el) => {
//                 el.classList.remove("navbar-nav-effect");
//             });
//         });
//     });
//     //closing menu by clicking outside
//     document.addEventListener("click", (e) => {
//         try {
//             // e.preventDefault();
//             let menu = document.querySelector(".mobile-nav-menu");
//             if (menu.classList.contains("navbar-nav-effect")) {
//                 if (!e.target.closest(".mobile-nav-menu, .menu-icon-img")) {
//                     menu.classList.remove("navbar-nav-effect");
//                 }
//             }
//         } catch (error) {}
//     });
// }

/**
 * disclaimer popup toggle
 */
{
    // alert(true);
    let popup = document.querySelector(".disclaimer-popup");
    let closeBtn = document.querySelectorAll(".close-disclaimer");
    let openBtn = document.querySelectorAll(".open-disclaimer");
    let search_background_form_wrapper = document.querySelector(
        ".search-background-form-wrapper"
    );
    let people_search_info = document.querySelector(".people-search-info");
    let footer = document.querySelector("footer");
    let arrest_adv_search = document.querySelector(".arrest-adv-search");
    let daily_arrest = document.querySelector(".daily-arrest");
    let daily_arrest_wrapper = document.querySelector(".daily-arrest-wrapper");
    let crime_alert_foot = document.querySelector(".crime-alert-foot");
    let submit_background_report_wrapper = document.querySelector(
        ".submit-background-report-wrapper"
    );
    let search_people_wrapper = document.querySelector(
        ".search-people-wrapper"
    );
    let search_people_des = document.querySelector(".search-people-des");
    //closing popup
    [].forEach.call(closeBtn, (el) => {
        el.addEventListener("click", (el) => {
            popup.classList.add("disclaimer-effect");
            try {
                search_background_form_wrapper.classList.add("d-flex");
            } catch (error) {}
            try {
                people_search_info.classList.add("d-flex");
            } catch (error) {}
            footer.classList.add("d-block");
            try {
                footer.classList.remove("d-none");
            } catch (error) {}
            try {
                arrest_adv_search.classList.remove("d-none");
            } catch (error) {}
            try {
                daily_arrest.classList.remove("d-none");
            } catch (error) {}
            try {
                daily_arrest_wrapper.classList.remove("d-none");
            } catch (error) {}
            try {
                crime_alert_foot.classList.remove("d-none");
            } catch (error) {}
            try {
                submit_background_report_wrapper.classList.remove("d-none");
            } catch (error) {}
            try {
                search_people_wrapper.classList.remove("d-none");
            } catch (error) {}
            try {
                search_people_des.classList.remove("d-none");
            } catch (error) {}
        });
    });
    //opening popup
    [].forEach.call(openBtn, (el) => {
        el.addEventListener("click", (e) => {
            popup.classList.remove("disclaimer-effect");
            try {
                search_background_form_wrapper.classList.remove("d-flex");
            } catch (error) {}
            try {
                people_search_info.classList.remove("d-flex");
            } catch (error) {}
            try {
                footer.classList.add("d-none");
            } catch (error) {}
            try {
                arrest_adv_search.classList.add("d-none");
            } catch (error) {}
            try {
                daily_arrest.classList.add("d-none");
            } catch (error) {}
            try {
                daily_arrest_wrapper.classList.add("d-none");
            } catch (error) {}
            try {
                crime_alert_foot.classList.add("d-none");
            } catch (error) {}
            try {
                submit_background_report_wrapper.classList.add("d-none");
            } catch (error) {}
            try {
                search_people_wrapper.classList.add("d-none");
            } catch (error) {}
            try {
                search_people_des.classList.add("d-none");
            } catch (error) {}
        });
    });
}

//cookie terms popup close
// {
//     let cookieCloseBtn = document.querySelectorAll(".accept-cookie-btn");
//     let cookiePopup = document.querySelectorAll(".cookie-term");
//     [].forEach.call(cookieCloseBtn, function (el) {
//         el.addEventListener("click", function () {
//             Array.from(cookiePopup).forEach((e) => {
//                 e.classList.add("d-none");
//             });
//             setCookie("cookie-term", "accepted", 365);
//         });
//     });
// }
/**
 * replacing url tag with anchor tag
 */
{
    let urlTag = document.querySelectorAll(".replace-tag url");
    Array.from(urlTag).forEach((el) => {
        let href = "";
        let content = el.innerHTML.toLowerCase();
        if (
            content.search("https://") < 0 &&
            content.search("http://") < 0 &&
            content.substring(0, 1) != "/"
        ) {
            href = "https://";
        }
        el.outerHTML = `<a href="${
            href + content
        }" target="_blank">${content}</a>`;
    });
}
/**
 * adding https:// to response url
 */
{
    let urlLink = document.querySelectorAll(".url-link");
    Array.from(urlLink).forEach((el) => {
        let href = "";
        let url = el.getAttribute("href");
        if (
            url.search("https://") < 0 &&
            url.search("http://") < 0 &&
            url.substring(0, 1) != "/"
        ) {
            href = "https://";
        }
        el.setAttribute("href", href + url);
    });
}
/**
 * scrolling to section with id using hash
 */
try {
    let hash = window.location.hash;
    if (hash.length) {
        // let elemId = hash.replace("#", "");
        let element = document.getElementById(hash);
        let offset = 0;
        let bodyRect = document.body.getBoundingClientRect().top;
        let elementRect = element.getBoundingClientRect().top;
        let elementPosition = elementRect - bodyRect;
        let offsetPosition = elementPosition - offset;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }
} catch (error) {}
